<template>
  <div class="p-4">
    <div class="flex items-center mb-3">
      <div
        class="p-1 px-2 border border-blue-600 rounded text-xs text-blue-500 w-20"
      >
        <i class="fas fa-sliders-h"></i>
        Filter
      </div>
      <span class="font-bold ml-2 text-sm uppercase text-blue-600"
        >ALARMS: {{ label }}</span
      >
    </div>
    <div id="chart" class="relative" style="height: 150px;">
      <VueApexCharts
        type="radialBar"
        height="200"
        :series="chartData"
        :options="chartOptions"
        class="absolute"
      />
      <div class="absolute">
        <div class="flex items-center mb-1" style="color: #C62828">
          <div class="h-2 w-2 rounded-full mr-1" style="background: #C62828"></div>
          <span class="cursor-pointer" @click="fetchAlarmNotification(location, 0)">Critical: {{ chartData[0] }}</span>
        </div>
        <div class="flex items-center mb-1" style="color: #EE9E3D">
          <div class="h-2 w-2 rounded-full mr-1" style="background: #EE9E3D"></div>
          <span class="cursor-pointer" @click="fetchAlarmNotification(location, 1)">Warning: {{ chartData[1] }}</span>
        </div>
        <div class="flex items-center mb-1" style="color: #52A2EC">
          <div class="h-2 w-2 rounded-full mr-1" style="background: #52A2EC"></div>
          <span class="cursor-pointer" @click="fetchAlarmNotification(location, 2)">Informational: {{ chartData[2] }}</span>
        </div>
      </div>
    </div>
    <AlarmTable
      :isButtonMuteShow="false"
      :visible="alarmTableDialogVisible"
      :notifications="notifications"
      :doesSoundPlay="doesAlarmSoundPlay"
      :locationAndSeverityLabel="locationAndSeverityLabel" />
  </div>
</template>

<script>
import AlarmTable from '@/components/Portal/AlarmTable.vue'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'

export default {
  props: {
    data: {
      type: Object
    },
    reload: {
      type: Boolean
    },
    label: {
      type: String
    },
    chartData: {
      type: Array
    },
    location: {
      type: String
    }
  },
  components: {
    AlarmTable,
    VueApexCharts
  },
  data: function () {
    const chartColors = {
      red: '#c62828',
      orange: 'rgb(255, 159, 64)',
      yellow: 'rgb(255, 205, 86)',
      green: 'rgb(75, 192, 192)',
      blue: 'rgb(54, 162, 235)',
      purple: 'rgb(153, 102, 255)',
      grey: 'rgb(201, 203, 207)'
    }
    return {
      doesAlarmSoundPlay: true,
      notifications: [],
      alarmTableDialogVisible: false,
      locationAndSeverityLabel: '',
      chartOptions: {
        chart: {
          height: 150,
          type: 'radialBar',
          sparkline: {
            enabled: true
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.fetchAlarmNotification(this.location, config.dataPointIndex)
            }
          }
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 230,
            hollow: {
              margin: 5,
              size: '30%',
              background: 'transparent',
              image: undefined
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                show: false
              }
            }
          }
        },
        grid: {
          padding: {
            top: -20,
            bottom: -20
          }
        },
        colors: [chartColors.red, chartColors.orange, chartColors.blue],
        labels: ['Critical', 'Warning', 'Informational'],
        legend: {
          show: false,
          floating: true,
          fontSize: '12px',
          position: 'right',
          offsetX: 120,
          offsetY: 0,
          labels: {
            useSeriesColors: true
          },
          markers: {
            size: 0
          },
          formatter: function (seriesName, opts) {
            return seriesName + ':  ' + opts.w.globals.series[opts.seriesIndex]
          },
          itemMargin: {
            vertical: 3
          }
        },
        responsive: [
          {
            breakpoint: 380,
            options: {
              legend: {
                show: false
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    getRandomInt(min = 0, max = 5, withDecimal = false) {
      return withDecimal
        ? (Math.random() * (max - min) + min).toFixed(2)
        : Math.floor(Math.random() * (max - min) + min)
    },
    getLabel(val) {
      return val + ' Litre'
    },
    render() {
      this.series = [
        this.chartData[0],
        this.chartData[1],
        this.chartData[2]
      ]
    },
    async fetchAlarmNotification(location, labelIndex) {
      // change location
      location = location === 'THMO' ? 'PICMO' : location

      let severity = 'CRITICAL'
      if (labelIndex === 1) severity = 'WARNING'
      else if (labelIndex === 2) severity = 'INFORMATIONAL'

      const res = await this.$axios.get(
        `Alarms/GetActiveAlarmsByTypeAndRoom?isDevice=true&room=${location}`
      )

      // set date format
      this.notifications = res.data?.ListAlarm?.map((x) => {
        x.ActiveTime = moment(x.ActiveTime).format('YYYY-MM-DD hh:mm:ss')
        return x
      })

      // filter by severity name
      this.notifications = this.notifications.filter(x => x.Severity === severity)

      this.locationAndSeverityLabel = ` | ${location} (${severity})`

      this.alarmTableDialogVisible = false
      this.doesAlarmSoundPlay = true
      setTimeout(() => {
        this.alarmTableDialogVisible = true
        this.doesAlarmSoundPlay = false
      }, 200)
    }
  }
}
</script>
